import { fetchAllTariffProducts } from 'Services/ProductManagement/Features/Product/productSlice'
import { useAppDispatch, useTypedSelector } from 'Store'
import { All_TARIFF_PRODUCTS_COUNT_PER_REQUEST } from 'Util/constants'
import { useEffect } from 'react'

function useTariffProducts(tariffId: string) {
  const dispatch = useAppDispatch()
  const { allTariffProducts, allTariffProductsLoading } = useTypedSelector(state => state.product)

  const fetchAllTariffProductsWithoutPagination = () => {
    dispatch(
      fetchAllTariffProducts({
        in_tariff: tariffId,
        bypass_pagination: true,
        count: All_TARIFF_PRODUCTS_COUNT_PER_REQUEST
      })
    )
  }

  useEffect(() => {
    fetchAllTariffProductsWithoutPagination()
  }, [])

  return {
    allTariffProducts,
    allTariffProductsLoading,
    fetchAllTariffProductsWithoutPagination
  }
}

export default useTariffProducts
